var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8V7C0 4.243 2.243 2 5 2H6V1C6 0.448 6.447 0 7 0C7.553 0 8 0.448 8 1V2H16V1C16 0.448 16.447 0 17 0C17.553 0 18 0.448 18 1V2H19C21.757 2 24 4.243 24 7V8H0ZM24 10V19C24 21.757 21.757 24 19 24H5C2.243 24 0 21.757 0 19V10H24ZM12 19C12 18.448 11.553 18 11 18H6C5.447 18 5 18.448 5 19C5 19.552 5.447 20 6 20H11C11.553 20 12 19.552 12 19ZM19 15C19 14.448 18.553 14 18 14H6C5.447 14 5 14.448 5 15C5 15.552 5.447 16 6 16H18C18.553 16 19 15.552 19 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsSelected);
export default __webpack_public_path__ + "static/media/appointments_selected.6b8983da8e5b0b252e1c10fe02d5f8d1.svg";
export { ForwardRef as ReactComponent };